var React = require('react');

function CalculatorAlt (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m20 21v8h-2v-3h-4v3h-2v-3h-5v2c0 .5522847.44771525 1 1 1h16c.5522847 0 1-.4477153 1-1v-7zm-2 0h-4v3h4zm2-5v3h5v-3zm-2 0h-4v3h4zm0-2v-3h2v3h5v-3h-18v3h5v-3h2v3zm-11 10h5v-3h-5zm0-5h5v-3h-5zm18-10v-5c0-.55228475-.4477153-1-1-1h-16c-.55228475 0-1 .44771525-1 1v5zm-18-8h18c1.1045695 0 2 .8954305 2 2v26c0 1.1045695-.8954305 2-2 2h-18c-1.1045695 0-2-.8954305-2-2v-26c0-1.1045695.8954305-2 2-2zm14 4v2h1v-2zm0-1h1c.5522847 0 1 .44771525 1 1v2c0 .55228475-.4477153 1-1 1h-1c-.5522847 0-1-.44771525-1-1v-2c0-.55228475.4477153-1 1-1z"}));
}

CalculatorAlt.defaultProps = {"height":"32","viewBox":"0 0 32 32","width":"32"};

module.exports = CalculatorAlt;

CalculatorAlt.default = CalculatorAlt;
